import type { CarrierTask, CarrierTripStopTask } from "@/api/carrier";

type WorkHoldTask =
  | Pick<CarrierTask, "cancellationReviewPending" | "workHold" | "shipment">
  | Pick<CarrierTripStopTask, "cancellationReviewPending" | "workHold">;

export function isTaskOnCancellationHold(task: WorkHoldTask): boolean {
  return Boolean(
    task.cancellationReviewPending ||
      task.workHold?.reason === "CANCELLATION_REVIEW" ||
      ("shipment" in task && task.shipment?.cancellationRequestedAt)
  );
}
